import styled from 'styled-components';
import { neutralColors, CTAColors } from '../../styles/colors/colors.js';
import { jsx } from 'react/jsx-runtime';

var StyledContent = styled.div.withConfig({
  displayName: "SkipLinkItem__StyledContent",
  componentId: "sc-7zqg5y-0"
})(["&&{display:flex;align-items:center;height:100%;box-sizing:border-box;margin:0 8px;}&&:focus{border-bottom:none;}"]);
var StyledButton = styled.button.withConfig({
  displayName: "SkipLinkItem__StyledButton",
  componentId: "sc-7zqg5y-1"
})(["&&{height:40px;color:", ";padding:0 8px;font-family:'source sans pro',system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI';font-size:14px;font-weight:600;border:none;background-color:transparent;cursor:pointer;}&&:focus{color:", ";outline-color:", ";}&&:not(:last-child) ", "{border-bottom:1px solid #cfd4da;}"], neutralColors.smoke, CTAColors.primaryVariant, CTAColors.primaryVariant, StyledContent);
var SkipLinkItem = function SkipLinkItem(_ref) {
  var href = _ref.href,
    label = _ref.label,
    onClick = _ref.onClick;
  var handleClick = function handleClick() {
    if (href) {
      var elementToScrollTo = document.getElementById(href.split("#")[1]);
      if (elementToScrollTo) {
        elementToScrollTo.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        elementToScrollTo.setAttribute("tabindex", "-1");
        elementToScrollTo.focus({
          preventScroll: true
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/jsx(StyledButton, {
    role: "listitem",
    onClick: handleClick,
    children: /*#__PURE__*/jsx(StyledContent, {
      children: label
    })
  });
};
SkipLinkItem.displayName = "SkipLinkItem";

export { SkipLinkItem };
